import React, { forwardRef } from 'react';

import clsx from 'classnames';

export const RadioButton = forwardRef(
  (
    {
      className,
      name = 'Name',
      id = 'ID',
      label,
      error,
      disabled,
      bold,
      ...props
    },
    ref
  ) => {
    const radioButtonClass = clsx(
      {
        'cdl-radio-button': true,
        'cdl-radio-button--error': error,
        'cdl-radio-button--disabled': disabled,
      },
      className
    );
    return (
      <label className={radioButtonClass} htmlFor={id}>
        <input
          ref={ref}
          className="cdl-radio-button__input"
          disabled={disabled}
          id={id}
          name={name}
          type="radio"
          {...props}
        />
        <span>
          <b>{label}</b>
        </span>
      </label>
    );
  }
);
